import React, { Component } from 'react';
import {Link} from 'react-router-dom';


function Referenzen () {

    return (
        <div className="contentContainer">
            <div className="referenzenContainer">
                <h2>Unsere Referenzen</h2>
                <div className="referenzenRow">
                    <div className="referenzenleft">
                        <div className="imgContainer">
                            <Link to="https://www.umbreit.de"><img src={'/assets/img/logo-umbreit.png'} alt=''/></Link>
                        </div>
                        <p>
                        <h3>G. Umbreit GmbH & Co. KG</h3>
                        Webservice und Medienzentrale für das Barsortiment G. Umbreit GmbH & Co. KG<br/>
                        <Link to="https://www.umbreit.de">www.umbreit.de</Link><br/>
                        Pressewebshop für Pressegrossos <br/>
                        <Link to="https://602410.pressewebshop2.de">www.pressewebshop2.de</Link><br/>
                        </p>
                    </div>
                    <div className="referenzenmiddle">
                        <div className="imgContainer">
                            <Link to="https://www.lkg.eu"><img src={'/assets/img/lkgagorando.png'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>LKG - Leipziger Kommissions- und Großbuchhandelsgesellschaft mbH</h3>
                        Einsatz von sys.mobil, Software für Verlagsvertretungen<br/>
                        <Link to="https://www.lkg.eu">www.lkg.eu</Link>
                        </p>
                    </div>
                    <div className="referenzenright">
                        <div className="imgContainer">
                            <Link to="https://www.ava.ch"><img src={'/assets/img/ava.jpg'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>AVA Verlagsauslieferung AG</h3>
                        B2B4D Datawarehouse und Content Management System für 
                        AVA Verlagsauslieferungen / Schweiz <br/>
                         <Link to="https://www.ava.ch">www.ava.ch</Link>
                        </p>
                    </div>

                </div>
                <div className="referenzenRow">
                    <div className="referenzenleft">
                        <div className="imgContainer">
                            <Link to="https://www.prolit.de"><img  src={'/assets/img/prolit_logo.gif'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>PROLIT Verlagsauslieferung GmbH</h3>
                        B2B4D Datawarehouse und Content Management 
                        System für die Prolit Verlagsauslieferung (prolit webline) und 
                        Vertretersoftware (webline mobil)<br/>
                        <Link to="https://www.prolit.de">www.prolit.de</Link>
                        </p>
                    </div>
                    <div className="referenzenmiddle">
                        <div className="imgContainer">
                            <Link to="https://www.balmer-bd.ch"><img className="bbdImg"src={'/assets/img/bbd.png'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>Balmer Bücherdienst AG</h3>
                        B2B4D Datawarehouse für die Verlage der Balmer Bücherdienst AG<br/>
                        Webservice für den Balmer Titelkatalog
                        <br/>
                        <Link to="https://www.balmer-bd.ch">www.balmer-bd.ch</Link>
                        </p>
                    </div>
                    <div className="referenzenright">
                        <div className="imgContainer">
                            <Link to="https://www.sbvv.ch"><img src={'/assets/img/lsbvv.svg'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>Schweizer Buchhandels- und Verlags-Verband SBVV</h3>
                        Content Management System für den Schweizer Buchhändler- und Verleger-Verband SBVV, Zürich
                        <br/>
                        <Link to="https://www.sbvv.ch">www.sbvv.ch</Link>
                        <br/>
                        Adressbuch des Schweizer Buchhandels<br/>
                        <Link to="https://www.sbvv.ch/who-is-who">www.sbvv.ch/who-is-who</Link>
                        <br/>
                        elektronisches Auslieferungsverzeichnis<br/>
                        <Link to="https://www.e-asv.ch">www.e-asv.ch</Link>
                        
                        </p>
                    </div>
                    
                </div>
                <div className="referenzenRow">
                    <div className="referenzenleft">
                        <div className="imgContainer">
                            <Link to="https://www.azb-online.de"><img src={'/assets/img/AZB.jpg'} alt=''/></Link>
                        </div>
                         <p>
                       <h3>Auslieferungszentrum Bercker</h3>
                        B2B4D Datawarehouse für das Auslieferungszentrum Bercker und Einsatz von sys.mobil, Software für Verlagsvertretungen<br/>
                         <Link to="https://www.azb-online.de">www.azb-online.de</Link>
                        </p>
                    </div>
                    <div className="referenzenmiddle">
                        <div className="imgContainer">
                            <Link to="https://www.rungeva.de"><img src={'/assets/img/Runge.jpg'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>Runge Verlagsauslieferung GmbH</h3>
                        Einsatz von sys.mobil, Software für Verlagsvertretungen<br/>
                         <Link to="https://www.rungeva.de">www.rungeva.de </Link>
                        </p>
                    </div>
                    <div className="referenzenright">
                        <div className="imgContainer">
                            <Link to="https://www.mvb-online.de"><img src={'/assets/img/buecherscheck.svg'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>MVB - Bücherscheck</h3>
                        Abrechnungssystem für die Bücherschecks der MVB<br/>
                        <Link to="https://www.mvb-online.de">www.mvb-online.de</Link>
                        </p>
                    </div>
                    
                </div>
                <div className="referenzenRow">
                    <div className="referenzenleft">
                        <div className="imgContainer">
                            <Link to="https://www.brocom.de"><img src={'/assets/img/brockhaus.gif'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>Brockhaus Kommissionsgeschäft GmbH</h3>
                        Einsatz von sys.mobil, Software für Verlagsvertretungen<br/>
                         <Link to="https://www.brocom.de">www.brocom.de</Link>
                        </p>
                    </div>
                    <div className="referenzenmiddle">
                        <div className="imgContainer">
                            <Link to="https://www.rungeva.de"><img src={'/assets/img/petersen.png'} alt=''/></Link>
                        </div>
                         <p>
                            <h3>Petersen Buchimport GmbH</h3>
                        Einsatz von sys.mobil, Software für den Außendienst
                        </p>
                    </div>
                    <div className="referenzenright">
                        <div className="imgContainer">
                            <Link to="https://www.mvb-online.de"><img src={'/assets/img/benno.png'} alt=''/></Link>
                        </div>
                         <p>
                            <h3>St. Benno Buch und Zeitschriften Verlagsgesellschaft mbH:</h3>
                        Einsatz von sys.mobil, Software für den Verlagsvertretungen
                        </p>
                    </div>
                    
                </div>
                    <div className="referenzenRow">
                    <div className="referenzenleft">
                        <div className="imgContainer">
                            <Link to="https://www.brocom.de"><img src={'/assets/img/mvb-isbn.png'} alt=''/></Link>
                        </div>
                         <p>
                        <h3>MVB ISBN</h3>
                        Einsatz von sys.mobil, Software für Verlagsvertretungen<br/>
                         <Link to="https://www.brocom.de">www.brocom.de</Link>
                        </p>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    )

}

export default Referenzen;